import { render, staticRenderFns } from "./base.vue?vue&type=template&id=46eb8d7c&scoped=true&"
import script from "./base.vue?vue&type=script&lang=js&"
export * from "./base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eb8d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\webapp_abroad\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46eb8d7c')) {
      api.createRecord('46eb8d7c', component.options)
    } else {
      api.reload('46eb8d7c', component.options)
    }
    module.hot.accept("./base.vue?vue&type=template&id=46eb8d7c&scoped=true&", function () {
      api.rerender('46eb8d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/base.vue"
export default component.exports